












































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { namespaced, NS_ADMIN } from "../../store/namespace";
import { DELETE_QUESTION } from "../../store/actions.names";
import RichTextEditor from "./RichTextEditor.vue";
import { enToBnNum } from "../../utils/common";
import { VueMathjax } from 'vue-mathjax'

import { API_HOST } from "@/global";

const OPTION = {
  option: { text: "", text_en: "", text_bn: "" },
  correct: false
};

const QUESTION_FORM = {
  options: [OPTION, OPTION, OPTION],
  text: "",
  text_en: "",
  text_bn: "",
  image: null,
  hint: "",
  hint_en: "",
  hint_bn: "",
  type: "radio",
  max_show: 3
};

@Component({
  name: "QuestionForm",
  components: {
    RichTextEditor,
    'vue-mathjax': VueMathjax
  }
})
export default class QuestionForm extends Vue {
  @Action(namespaced(NS_ADMIN, DELETE_QUESTION)) deleteQuestion: any;
  @Prop() lang: string;
  @Prop() value: any;
  @Prop() questionIndex: number;
  shouldEmit: boolean = true;
  internalValue: any | null = null;
  radioCorrect: null | number = null;
  enToBnNum: any = enToBnNum;
  

  API_HOST: string = API_HOST;

  generateImageUrl(){
    if(typeof(this.value.image) == "object"){
      const file = this.value.image;
      return URL.createObjectURL(file);
    }else{
      return this.API_HOST + this.value.image;
    }
  }

  translations: any = {
    qs: {
      en: "Question",
      bn: "প্রশ্ন"
    },
    hint: {
      en: "Hint",
      bn: "সাহায্য (hint)"
    },
    option: {
      en: "Option",
      bn: "উত্তর"
    },
    options: {
      en: "Options to Show",
      bn: "দেখানো উত্তর সংখ্যা"
    },
    choices: {
      single: {
        en: "Single Choice",
        bn: "একটি সঠিক উত্তর"
      },
      multiple: {
        en: "Multiple Choice",
        bn: "একাধিক সঠিক উত্তর"
      },
      blanks: {
        en: "Fill in the Blanks",
        bn: "শূন্যস্থানপূরণ"
      }
    },
    newt: {
      en: "New",
      bn: "নতুন"
    }
  };

  // processedOptions(corrects: any | null = null, options: any | null = null) {
  //   if (corrects === null) corrects = this.corrects;
  //   if (options === null) options = this.options;
  //   return {
  //     correct: corrects.map(val => {
  //       return options[val];
  //     }),
  //     options: options.filter((val, idx) => {
  //       return corrects.indexOf(idx) == -1;
  //     })
  //   };
  // }

  getRadioCorrectVal(options) {
    const idx = options.findIndex((item, idx) => {
      return item.correct;
    });
    return idx < 0 ? null : idx;
  }

  getCheckBoxCorrectVal(options) {
    const vals = options.filter((item, idx) => {
      return item.correct;
    });
    return vals.map((item, idx) => {
      return item.id;
    });
  }

  @Watch("value", { immediate: true })
  handleValueChange(val: any, oldVal: any) {
    // // console.log("valueChange");
    this.shouldEmit = false;
    const data = JSON.parse(JSON.stringify(val));
    // data.options = [...data.correct, ...data.options];
    // data.correct = [...Array(data.correct.length).keys()];
    if (val.type == "radio") {
      this.radioCorrect = this.getRadioCorrectVal(val.options);
    }
    // else {
    //   this.radioCorrect = this.getCheckBoxCorrectVal(val.options);
    // }
    this.internalValue = data;
    this.internalValue.image = val.image;
  }

  addOption() {
    this.internalValue.options.push(JSON.parse(JSON.stringify(OPTION)));
  }

  handleQuestionTypeChange(val) {
    val = (event.target as HTMLInputElement).value;
    this.internalValue.type = val;
  }

  deleteOption(idx) {
    this.internalValue.options.splice(idx, 1);
    var index = this.internalValue.corrects.indexOf(idx);
    if (index > -1) {
      this.internalValue.corrects.splice(index, 1);
    }
  }

  handleQuestionImage(e) {
    var files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.internalValue.image = files[0];
    this.shouldEmit = true;
  }

  radioInput(event, idx) {
    const data = JSON.parse(JSON.stringify(this.internalValue.options));
    const prev = data[idx].correct;
    const upData = data.map((item, index) => {
      item.correct = index != idx ? false : !prev;
      return item;
    });
    this.$set(this.internalValue, "options", upData);
  }

  @Watch("radioCorrect")
  handleRadioCorrect(val: any, oldVal: any) {
    if (this.internalValue.type === "radio") {
      const data = JSON.parse(JSON.stringify(this.internalValue.options));
      for (const opt of data) {
        opt.correct = false;
      }
      if (val !== null) {
        data[val].correct = true;
      }
      // console.log(data);
      this.shouldEmit = true;
      this.$set(this.internalValue, "options", data);
    }
  }

  @Watch("internalValue", { deep: true })
  handleInternalValueChange(val: any, oldVal: any) {
    // console.log(val);
    if (this.shouldEmit) {
      const data = JSON.parse(JSON.stringify(val));

      data.image = val.image;
      // Object.assign(data, this.processedOptions(val.correct, val.options));
      this.$emit("input", data);
    } else {
      this.shouldEmit = true;
    }
  }
}
